import $ from "jquery";

import initPermalink from "./permalink_modal";

const methodologyRedirect = function() {
  $("#methodologyRedirect").on("click", function () {
    $("#faq-li").removeClass("active");
    $("#support-faq").removeClass("active");
    $("#faq-a").attr("aria-expanded", "false");

    $("#meth-li").addClass("active");
    $("#support-methodology").addClass("active");
    $("#meth-a").attr("aria-expanded", "true");
  });
};

const setTitleHeight = function() {
  var x = 0;
  $(".video-info .video-title-header")
    .each(function (id, it) {
      if ($(it).height() > x) {
        x = $(it).height();
      }
    })
    .height(x);
};

const showTab = function() {
  // Javascript to enable link to tab
  const queryString  = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let selectedTab = urlParams.get("tab");

  if (urlParams.has("tab")) {
    $("[href='" + "#" + selectedTab + "']").trigger("click");
  }
};

const initMethods = function() {
  initPermalink();
  setTitleHeight();
  methodologyRedirect();
  showTab();
};

$(document).on("ready", function () {
  initMethods();
});
